import { createSlice } from '@reduxjs/toolkit';
import { brandGetLandingPage3 } from './brandAsyncThunk';

const brandGetLandingPageSlice3 = createSlice({
  name: "brand",
  initialState: {
    payload: {},
    isLoading: false,
    isSuccess: false,
    isFail: false,
  },
  reducers: {},
  extraReducers: {
    [brandGetLandingPage3.pending]: (state, action) => {
      state.isLoading = true;
      state.isSuccess = false;
      state.isFail = false;
    },
    [brandGetLandingPage3.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.isSuccess = true;
      state.payload = { ...action.payload.list };
    },
    [brandGetLandingPage3.rejected]: (state, action) => {
      state.isLoading = false;
      state.isFail = true;
    },
  },
});

export default brandGetLandingPageSlice3.reducer;